import Splide from '@splidejs/splide';

const SpeakersSlider = () => {
    const selector = '.ia-speakers-slider .splide';
    const init = () => {
        const splide = new Splide(selector, {
            type   : 'fade',
            perPage: 1,
            perMove: 1,
            gap: '25px',
            pagination: false,
        }).mount();

        splide.on('click', function () {
            splide.go('+1');
        });
    };

    if ($(selector).length > 0) {
        init();
    }

    /* return ({
        init,
    }); */
}
export default SpeakersSlider;
